import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=598e734b&scoped=true"
import script from "./ProductOrder.vue?vue&type=script&lang=js"
export * from "./ProductOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductOrder.vue?vue&type=style&index=0&id=598e734b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598e734b",
  null
  
)

export default component.exports